import { useEffect, useMemo } from 'react'

export const isHTMLElementsContainsTheTarget = (
  htmlElementsArray: (HTMLElement | SVGElement | null)[],
  target: Node
): boolean =>
  !!htmlElementsArray.find(
    htmlElement => htmlElement && htmlElement.contains(target)
  )

export const isIgnoredElementOrChild = (
  element: Element | null,
  ignoredClassNames: Array<string>
): boolean => {
  if (element === null) {
    return false
  }

  if (
    Array.from(element.classList).some(className =>
      ignoredClassNames.includes(className)
    )
  ) {
    return true
  }

  return isIgnoredElementOrChild(element.parentElement, ignoredClassNames)
}
export function useOnClickOutside(
  refs: Array<HTMLElement | SVGElement | null> | null,
  handler: (event: Event) => unknown,
  ignoredClassNames?: Array<string>,
  containerId?: string
): void {
  const container = useMemo(() => {
    const targetContainer = containerId
      ? document.getElementById(containerId)
      : null
    return targetContainer ?? document
  }, [containerId])

  useEffect(() => {
    const listener = (event: Event) => {
      const isRefsContainsTheTarget =
        !refs ||
        (event.target instanceof Node &&
          isHTMLElementsContainsTheTarget(refs, event.target))

      const ignoredClassNamesCondition =
        ignoredClassNames &&
        event.target instanceof Element &&
        isIgnoredElementOrChild(event.target, ignoredClassNames)

      if (isRefsContainsTheTarget || ignoredClassNamesCondition) {
        return
      }

      handler(event)
    }

    container.addEventListener('mousedown', listener)
    container.addEventListener('touchstart', listener)

    return () => {
      container.removeEventListener('mousedown', listener)
      container.removeEventListener('touchstart', listener)
    }
    // TODO: Recheck this, you sure you don't need to pass containerId?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs, handler, ignoredClassNames])
}
